import { noRequirement } from './constants';
import type { MinQuantityStrategy } from './types';

export const DefaultMinQuantityStrategy = {
  calculateRequirement(_site, _pricing, _marketCode) {
    return noRequirement;
  },
} satisfies MinQuantityStrategy;
